import { render, staticRenderFns } from "./BrandImageUploader.vue?vue&type=template&id=50210750"
import script from "./BrandImageUploader.vue?vue&type=script&lang=js"
export * from "./BrandImageUploader.vue?vue&type=script&lang=js"
import style0 from "./BrandImageUploader.vue?vue&type=style&index=0&id=50210750&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports